import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTASection = () => (
  <section className="relative bg-[#0A0A0A] py-24 sm:py-32 overflow-hidden">
    <div className="absolute inset-0 grid-lines opacity-30" />
    <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#5CC528]/10 rounded-full blur-[120px]" />
    <div className="relative max-w-[1100px] mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <p className="text-[#5CC528] text-sm uppercase tracking-[0.25em] mb-6">Enerjinizi Dönüştürün</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display font-light text-4xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] text-white">
          Güneş bedava.<br />
          <span className="text-[#5CC528]">Faturanız</span> neden değil?
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 text-neutral-400 text-lg max-w-2xl mx-auto leading-relaxed">
          Ücretsiz keşif ve fizibilite için bize ulaşın. Çatınıza ya da arazinize özel
          anahtar teslim GES projesini birlikte tasarlayalım.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/iletisim"
            data-testid="cta-contact-btn"
            className="inline-flex items-center justify-center gap-2 bg-[#5CC528] text-black font-semibold px-8 py-4 rounded-full hover:bg-[#4AA020] transition-colors duration-200"
          >
            Ücretsiz Teklif Al <ArrowUpRight size={18} />
          </Link>
          <Link
            to="/hesaplama"
            data-testid="cta-calc-btn"
            className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-semibold px-8 py-4 rounded-full hover:border-[#5CC528] hover:text-[#5CC528] transition-colors duration-200"
          >
            GES Hesaplama Aracı
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
